import { Card, CardHeader } from '@mui/material';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

export const StyledCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(5),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  borderRadius: theme.spacing(1),
}));

export const StyledCardHeader = styled(CardHeader)(() => ({
  padding: 0,
  '.MuiCardHeader-title': {
    fontWeight: 700,
    fontSize: '1.25rem',
    lineHeight: '1.75rem',
  },
}));

export const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    fontWeight: 500,
    color: '#64748b',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: '14px',
  },
}));

export const StyledNoDataCell = styled(StyledTableCell)(() => ({
  textAlign: 'center',
  fontFamily: '"Inter", sans-serif',
  fontSize: '14px',
  color: '#6b7280',
}));

export const StyledTableRow = styled(TableRow)(() => ({
  '&:hover': {
    backgroundColor: '#f1f5f9',
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));
